module.exports = __webpack_public_path__ + "static/img/1667305372787783.5f00b61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/energy/1667305372787783.jpg
// module id = 47E2
// module chunks = 4